<template>
<div class="page">
    <baidu-map
        style="display:flex;flex-direction: column-reverse;" 
        class="map"
        id="allmap"
        @ready="mapReady"
        @click="getLocation"
        :scroll-wheel-zoom="true"
      >
        <div style="">
          <bm-auto-complete v-model="searchJingwei" :sugStyle="{zIndex: 999999}">
            <van-field
                v-model="searchJingwei"
                placeholder="输入地址"
                style="width: 100%;line-height:40px;"
            />
          </bm-auto-complete>
          <div style="width: 100%;text-align: center;margin-bottom: 10px;">
            <el-button style="background: #EAF5E7;padding:5px 20px;border-radius: 10px;margin:10px;" type="primary" @click="getBaiduMapPoint">搜索</el-button>
          </div>
          
        </div>
        <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
        <bm-marker v-if="infoWindowShow" :position="{lng: longitude, lat: latitude}">
          <bm-label content="" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/>
        </bm-marker>
        <bm-info-window :position="{lng: longitude, lat: latitude}" :show="infoWindowShow" @clickclose="infoWindowClose">
          <p>{{searchJingwei}}</p>
        </bm-info-window>
      </baidu-map>
</div>
</template>

<script>
// import BmView from 'vue-baidu-map/components/map/MapView'; //地图视图
// import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch'; //搜索
// import BmMarker from 'vue-baidu-map/components/overlays/Marker'; //点标注
// import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'; //标注弹窗
export default {
    components: {
        // BmView,
        // BmLocalSearch,
        // BmMarker,
        // BmInfoWindow
    },
    data() {
        return {
            searchJingwei:'',
            infoWindowShow:false,
            longitude:'',
            latitude:'',
            point:''
        }
    },
    methods: {
        mapReady({ BMap, map }) {
            // 选择一个经纬度作为中心点
            this.point = new BMap.Point(113.27, 23.13);
            map.centerAndZoom(this.point, 12);
            this.BMap=BMap
            this.map=map
            },
            //点击获取经纬度
            getLocation(e){
            this.longitude=e.point.lng
            this.latitude=e.point.lat
            this.infoWindowShow=true
            },
            getBaiduMapPoint(){
                let that=this
                let myGeo = new this.BMap.Geocoder()
                myGeo.getPoint(this.searchJingwei,function(point){
                    if(point){
                    that.map.centerAndZoom(point,15)
                    that.latitude=point.lat
                    that.longitude=point.lng
                    that.infoWindowShow=true
                    }

                })
            },
            //信息窗口关闭
            infoWindowClose(){
                this.latitude=''
                this.longitude=''
                this.infoWindowShow=false
            },
    },
    mounted() {
        // if(this.$route.query.address ){
        //     this.searchJingwei=decodeURIComponent(this.$route.query.address)
        //     setTimeout(()=>{
        //         this.getBaiduMapPoint()
        //     },1000)
     
        // }
    }
}
</script>

<style lang="scss" scoped>

.page {
    background-color: #fff;
    width: 100%;
    height: 100vh;

    .map{
        width: 100%;
        height: 100vh;
    }
   
}
</style>
